<div class="breadcrumb-container breadcrumb-mobile" data-cy="breadcrumb-banner">
  @for (breadcrumb of item().breadcrumbWithIds; track breadcrumb; let i = $index) {
    <span class="breadcrumb">
      @if (i !== 0) {
        <cue-icon [icon]="ICONS.cueArrowRight" />
      }
      <span class="part">{{ breadcrumb.item2 | localizedString }}</span>
    </span>
  }
</div>

<div class="detail-wrapper">
  <div class="room-info mt-2" data-cy="info-block">
    @if (item().schedule) {
      <div class="schedule-status mt-2" [class.with-heading]="item().schedule.subject || item().schedule.organizer">
        <span class="status-tag" [ngStyle]="availabilityColor()">
          {{ availabilityText() | transloco }}
        </span>

        @if (item().schedule.subject || item().schedule.organizer) {
          <div class="schedule-heading">
            <span class="subject">{{ item().schedule.subject }}</span>
            @if (item().schedule.realStart && item().schedule.realEnd) {
              <div class="organizer">
                <span class="label">{{ item().schedule.realStart | date: 'dd.MM. HH:mm' }} - </span>
                <span class="value">{{ item().schedule.realEnd | date: 'dd.MM. HH:mm' }}</span>
              </div>
            }

            @if (item().schedule.organizer) {
              <div class="organizer">
                <span class="label">{{ translation.reservationPopup.organizer | transloco }} :</span>
                <span class="value">{{ item().schedule.organizer }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (item() && item()?.workingHours?.workingHoursSetting) {
      <cue-working-hours [workingHourInfo]="item()" />
    }

    @if (item()) {
      <table>
        @if (item().showCodeInDetail) {
          <tr>
            <th>
              <div>
                {{ translation.resourceDetail.qrCode | transloco }}
              </div>
            </th>
            <td>
              {{ item().qrCode }}
            </td>
          </tr>
        }
        @if ((item().name | localizedString) || (item().displayNameForApp | localizedString)) {
          <tr>
            <th>
              <div>
                {{ translation.resourceDetail.name | transloco }}
              </div>
            </th>
            <td>
              {{ mapItemName() }}
            </td>
          </tr>
        }
        @if (item().qrCategoryName) {
          <tr>
            <th>
              <div>
                {{ translation.resourceDetail.qrCategoryName | transloco }}
              </div>
            </th>
            <td>
              @if (!!item().qrCategoryIcon) {
                <img
                  [src]="item().qrCategoryIcon"
                  [class.img-cover]="item().imagePreferCover"
                  [ngStyle]="{
                    'object-position': item().imageObjectPosition,
                  }"
                  class="h-5 w-5 max-w-none categoryIcon"
                />
              }
              {{ item().qrCategoryName | localizedString }}
            </td>
          </tr>
        }

        @if (item().resourceTypeName | localizedString) {
          <tr>
            <th>
              {{ translation.resourceDetail.type | transloco }}
            </th>
            <td>
              @if (item().resourceTypeIcon) {
                <img
                  [src]="item().resourceTypeIcon"
                  [class.img-cover]="item().imagePreferCover"
                  [ngStyle]="{
                    'object-position': item().imageObjectPosition,
                  }"
                  class="h-5 w-5 max-w-none categoryIcon"
                />
              }
              {{ item().resourceTypeName | localizedString }}
            </td>
          </tr>
        }
        @if (item().isCapacityUnlimited || item().capacity != null) {
          <tr>
            <th>
              <div>
                {{ translation.resourceDetail.capacity | transloco }}
              </div>
            </th>
            <td>
              {{ item().isCapacityUnlimited ? (translation.common.unlimited | transloco) : item().capacity }}
            </td>
          </tr>
        }
      </table>

      @if (item().qrCodes | poisCanBeShownInResource; as poisForResourceDetailList) {
        <cue-pois [pois]="poisForResourceDetailList" [selectedQrCodeId]="qrCodeId()" [links]="false" />
      }
    }
    @if (item() && item().objects?.length > 0) {
      <cue-controllable-objects
        ignoreErrors="true"
        [objectList]="item().objects"
        [qrCodeId]="item().qrCodeId"
        [qrCodeListOfResource]="item().qrCodes | qrIdList"
      />
    }
    @if (item().resourceDescription) {
      <div>
        <div
          class="break-words custom-quill-styles"
          [innerHTML]="item().resourceDescription | localizedString | cueCustomUnsafeSanitize"
        ></div>
      </div>
    }
    @if (item().unitInformation) {
      <hr />
      <cue-unit-detail [unitInfo]="item().unitInformation" />
    }

    @for (simpleFilter of simpleFilters(); track simpleFilter) {
      @if (simpleFilter.visible && simpleFilter.value.value) {
        <table>
          <tr>
            @if (simpleFilter.value.imageUrl) {
              <th>
                <div class="flex">
                  <img
                    [class.img-cover]="item().imagePreferCover"
                    [ngStyle]="{
                      'object-position': item().imageObjectPosition,
                    }"
                    [src]="simpleFilter.value.imageUrl | imageWidth: 30"
                    class="mr-3"
                  />
                  {{ simpleFilter.name | localizedString }}
                </div>
              </th>
              <td>
                @if (simpleFilter.value.value === true) {
                  <cue-icon [icon]="ICONS.cueCheck" class="correct" />
                }

                @if (simpleFilter.value.value === false) {
                  <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
                }

                @if (simpleFilter.value.value !== true && simpleFilter.value.value !== false) {
                  <div [innerHTML]="simpleFilter.value.value | localizedString | cueCustomUnsafeSanitize"></div>
                }
              </td>
            } @else {
              <th>
                <div>
                  {{ simpleFilter.name | localizedString }}
                </div>
              </th>
              <td>
                @if (simpleFilter.value.value === true) {
                  <cue-icon [icon]="ICONS.cueCheck" class="correct" />
                }

                @if (simpleFilter.value.value === false) {
                  <cue-icon [icon]="ICONS.cueClose" class="incorrect" />
                }

                @if (simpleFilter.value.value !== true && simpleFilter.value.value !== false) {
                  <div
                    [innerHTML]="simpleFilter.value.value | localizedString | cueCustomUnsafeSanitize"
                    class="custom-html"
                  ></div>
                }
              </td>
            }
          </tr>
        </table>
      }
    }

    @if (item()) {
      <div class="content-centerer-inner">
        @for (enumerableFilter of enumerableFilters(); track enumerableFilter) {
          @if (enumerableFilter.visible) {
            <ul class="room-properties">
              <div class="item-label">
                {{ enumerableFilter.name | localizedString }}
              </div>
              @for (value of enumerableFilter.value; track value) {
                <li>
                  <div class="img-wrapper">
                    <img
                      [ngStyle]="{
                        'object-position': item().imageObjectPosition,
                      }"
                      [class.img-cover]="item().imagePreferCover"
                      [src]="value.imageUrl | imageWidth: 30"
                    />
                  </div>
                  <span class="descriptionText">
                    {{ value.title | localizedString }}
                  </span>
                </li>
              }
            </ul>
          }
        }
      </div>
    }
  </div>

  @if (item().audioUrl | localizedString) {
    <audio controls [src]="item().audioUrl | localizedString"></audio>
  }

  @if (item().files?.length > 0) {
    <hr />
  }
  <cue-file-gallery [files]="item().files" />
</div>

<!--<div class="breadcrumb-container">-->
<!--    @for (item of breadcrumb(); track item; let i = $index) {-->
<!--        <span class="breadcrumb">-->
<!--            @if (i !== 0) {-->
<!--                <cue-icon [icon]="ICONS.cueArrowRight" />-->
<!--            }-->
<!--            <span class="part">{{ item().name }}</span>-->
<!--        </span>-->
<!--    }-->
<!--</div>-->

<!--<cue-working-hours [workingHourInfo]="resource()" />-->

<!--@if (configService.value.infoSettings.descriptionVisible) {-->
<!--    <p class="descriptionText room-description" [innerHTML]="resource().description | localizedString | cueCustomUnsafeSanitize"></p>-->
<!--}-->

<!--<div class="grid grid-cols-2 gap-4">-->
<!--    <span class="key">{{ translation.leftMenu.type | transloco }}</span>-->
<!--    <span class="value">{{ resource().name }}</span>-->

<!--    @if (configService.getResourceTypeFromId(resource().resourceTypeId).capacityVisible) {-->
<!--        <span class="key">{{ translation.resourceDetail.capacity | transloco }}</span>-->
<!--        <span class="value">{{ resource().capacity }}</span>-->
<!--    }-->

<!--    @for (simpleFilter of configService.getSimpleFiltersByResourceTypeId(resource(), translocoService); track simpleFilter) {-->
<!--        @if (simpleFilter.value !== undefined && simpleFilter.value !== null && simpleFilter.value !== '') {-->
<!--            <span class="key">{{ simpleFilter.name | localizedString }}</span>-->
<!--            @if (simpleFilter.value === true) {-->
<!--                <cue-icon [icon]="ICONS.cueCheck" class="correct" />-->
<!--            }-->

<!--            @if (simpleFilter.value === false) {-->
<!--                <cue-icon [icon]="ICONS.cueClose" class="incorrect" />-->
<!--            }-->

<!--            @if (simpleFilter.value !== true && simpleFilter.value !== false) {-->
<!--                <div [innerHTML]="simpleFilter.value | localizedString | cueCustomUnsafeSanitize"></div>-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--    @for (enumerableFilter of configService.getEnumerableFiltersByResourceTypeId(resource()); track enumerableFilter) {-->
<!--        @if (enumerableFilter.visible) {-->
<!--            <ul class="room-properties">-->
<!--                <div class="item-label">-->
<!--                    {{ enumerableFilter.name | localizedString }}-->
<!--                </div>-->
<!--                @for (value of enumerableFilter.value; track value) {-->
<!--                    <li>-->
<!--                        <div class="img-wrapper">-->
<!--                            <img [class.!object-cover]="value.imagePreferCover" [src]="value.imageUrl | imageWidth: 50" />-->
<!--                        </div>-->
<!--                        <span class="descriptionText">-->
<!--                            {{ value.title | localizedString }}-->
<!--                        </span>-->
<!--                    </li>-->
<!--                }-->
<!--            </ul>-->
<!--        }-->
<!--    }-->
<!--</div>-->

<!--@for (qrCode of serverDetail()?.qrCodes; track qrCode.qrCodeId) {-->
<!--    <cue-poi-->
<!--        [poi]="qrCode"-->
<!--        link="false"-->
<!--        class="cursor-pointer"-->
<!--        [routerLink]="[]"-->
<!--        [queryParams]="{ multiview: qrCode.qrCodeId }"-->
<!--        queryParamsHandling="merge"-->
<!--        [selected]="qrCode.qrCodeId === this.qrCodeId()"-->
<!--    />-->
<!--}-->

<!--<div class="delimiter"></div>-->
<!--<cue-file-gallery [files]="resource().files" />-->
